import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { SideBySideWidgetsType } from '../../types'

const SideBySideTopicInaccessibleGuard: WidgetGuard = ({ widgetId, children }) => {
  const { t } = useTranslation()
  const { topicInfos } = useDashboardWidgetSetting<SideBySideWidgetsType>(widgetId)
  const topicLength = topicInfos?.length ?? 0

  return !topicLength ? <ErrorMessage>{t('topicInaccessible')}</ErrorMessage> : children
}

export default SideBySideTopicInaccessibleGuard
